import { routes as manutencao } from './manutencao'
import { routes as matriculainicial } from './matriculainicial'
import { routes as situacaofinal } from './situacaofinal'

export default [
  {
    path: '/censoescolar',
    name: 'Censo Escolar',
    description: 'Censo Escolar',
    children: [
      ...manutencao,
      ...matriculainicial,
      ...situacaofinal
    ],
    goesToMenu: true
  }
]
